<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements">
<h1>Acknowledgements</h1>
<p>To all my family, friends and acquaintances: thank you for your continued support and encouragement while I was writing this, my second book, particularly my sister, Jules, in London, my good friend, Leonard, from Wales/London and lastly but not least, my bloody good mate, Kurt, in Sydney.</p>
<p style="text-indent:00em;">Also thank you to the team at Austin Macauley Publishers, in London.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7bbcadd4